/**
 * Removes any accidental search/hash suffix from a dynamic route param.
 *
 * @param value - Raw route param value from the router.
 * @returns The cleaned route param, or the original empty value.
 */
export const sanitizeRouteParam = (value?: string): string | undefined => {
  if (!value) {
    return value
  }

  const [sanitized] = value.split(/[?#]/, 1)
  return sanitized || undefined
}
